<script lang="ts">
  import { getNow, getTimeZone } from "../data/clock";
  import { getStartOfDay, getEndOfDay } from "../support/dates";

  export let time = getNow();
  export let timeZone = getTimeZone();

  export let onChange = () => {};

  $: startOfDay = getStartOfDay($time, $timeZone);
  $: endOfDay = getEndOfDay($time, $timeZone);

  $: min = startOfDay.getTime();
  $: max = endOfDay.getTime();
  $: value = $time.getTime();

  const timeTravel = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const next = target.valueAsNumber;
    const now = new Date(next);

    time.override = true;
    time.set(now);

    onChange();
  };
</script>

<label>
  <span class="sr-only">Adjust time of day</span>
  <input type="range" {min} {max} {value} on:input={timeTravel} />
</label>

<style>
  label {
    flex: 1 1;
  }

  input[type="range"] {
    width: 100%;
  }
</style>
